module.exports = __webpack_public_path__ + "static/media/microeconomics-not-enrolled.30b98cca.svg";